import React from "react";
import { Container, Title, Text, Button, Group, Space } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { Logo } from "../../shared/svg";

const ErrorPage = () => {
  const { t } = useTranslation();

  const handleGoHome = () => {
    window.location.href = "/";
  };

  return (
    <Container size="xs" style={{ textAlign: "center", paddingTop: "150px" }}>
      <Logo width={284} height={58} />

      <Title order={1} style={{ color: "red", textAlign: "center" }}>
        {t("error_title")}
      </Title>
      <Space h="md" />
      <Text size="lg" color="dimmed">
        {t("error_message")}
      </Text>
      <Space h="md" />
      <Group style={{ justifyContent: "center" }}>
        <Button onClick={handleGoHome} color="purple">
          {t("go_home")}
        </Button>
      </Group>
    </Container>
  );
};

export default ErrorPage;
